
export default (
  {
    pnr,
    actionType,
    tierLevel,
    ffProgram,
    totalPassenger,
    passengerCP,
    seatType,
    spid,
    route,
    storefront,
  }) => {
  return {
    event: 'CorporatePriority',
    pnr: pnr,
    actionType: actionType,
    tierLvl: tierLevel ? tierLevel : 'No FF',
    ffProgram: ffProgram ? ffProgram : 'No FF',
    totalPassenger: totalPassenger,
    passengerCP: passengerCP,
    seatType: seatType,
    spid: spid ? spid : 'NA',
    route: route,
    storefront: storefront,
  };
};